<section>
    <div>
        <video style="z-index: 0;" id="loginVideo" playsinline autoplay class="videoBg" (ended)="endVideo()">
            <source src="https://eventbucket.multitvsolution.com/ikolive/outer1.mp4" type="video/mp4">
        </video>
    </div>
    <span id="skip">
        <a class="nav-link sign" (click)="skip()" title="skip" role="button">
            SKIP</a>
    </span>
    <span *ngIf="mute">
        <span id="mute">
          <a class="nav-link sign" (click)="muteButton()" title="MUTE" role="button">
              MUTE</a>
        </span>
      </span>
      <span *ngIf="unmute">
        <span id="unmute" >
          <a class="nav-link sign" (click)="unmuteButton()" title="UNMUTE" role="button">
              UNMUTE</a>
        </span>
      </span>
</section>